export enum Constants {
  QR_MANAGER_SET_ITEMS = 'QR_MANAGER_SET_ITEMS',
  QR_MANAGER_SET_LOADING = 'QR_MANAGER_SET_LOADING'
}